module.exports = __webpack_public_path__ + "static/media/hat-winter.2a3cbfc9.svg";